export type { InfoListProps } from "./info-list";
export { InfoList } from "./info-list";
